<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj profil' : '' }}</v-flex>

    <profile-form :schema="$schema" :edit="!!id" :simple="true" :show="show" :official="true" />

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/partner_profile.schema';
import ProfileForm from '../../profile/ProfileForm';

const emptyData = () => ({
  login: '',
  profile: {
    firstName: '',
    lastName: '',
    type: ProfileType.PARTNER,
    email: '',
    phoneNumber: '',
    companyName: '',
    companyPosition: ''
  }
});

// @vuese
// Modal dodawnia/edycji profilu partnera
// @group Partners-Profile
export default {
  components: { modal, ProfileForm },
  mixins: [manageMixin('profiles', {}, emptyData)],
  schema,
  props: {
    // Identyfikator
    id: { type: String, required: false },
    // Partner
    partner: { type: Object, required: true }
  },
  methods: {
    // @vuese
    // Pobieranie id profilu
    getId() {
      return this.stateData.profile.id;
    },
    // @vuese
    // aktualizacja profilu partnra
    update() {
      this.model.profile.userId = this.id;
      this.$emit('update', {
        id: this.getId(),
        ...this.model
      });
    }
  },
  watch: {
    show(bool) {
      if (bool) {
        this.$schema.profile.companyName.$setData(this.partner.name);
      }
    }
  }
};
</script>
